import React, { createContext, type ReactNode, useContext, useMemo } from 'react'

const MergeGridContext = createContext<MergeGridValue | null>(null)

export const useMergeGridContext = (): MergeGridValue => {
  const context = useContext(MergeGridContext)
  if (!context) throw new Error('useMergeGridContext needs MergeGridProvider as a parent.')
  return context
}

type MergeGridValue = {
  showThirdColumn: boolean
}

type MergeGridProviderProps = {
  children: ReactNode
  showThirdColumn: boolean
}

export default function MergeGridProvider({ children, showThirdColumn }: MergeGridProviderProps): JSX.Element {
  const value: MergeGridValue = useMemo(
    () => ({
      showThirdColumn,
    }),
    [showThirdColumn]
  )

  return <MergeGridContext.Provider value={value}>{children}</MergeGridContext.Provider>
}
